import { IAssetHandle, Sound, SoundResource, inject, view } from "@spawn/core";
import { ReelView, ReelViewAddon, SymbolView } from "@spawn/slot-machine";
import { NudgeUpService } from "../services/nudgeUpService";

interface ReelTeaserAddonOptions {
	teaserSoundResource: IAssetHandle<SoundResource>;
}

/**
 * This addon plays a *single* teaser sound when a reel contains 1+ mystery symbols.
 */
@view
export class ReelTeaserAddon extends ReelViewAddon {
	@inject protected readonly nudgeUpService!: NudgeUpService;

	private readonly teaserSound!: Sound;

	constructor(options: ReelTeaserAddonOptions) {
		super();
		this.teaserSound = new Sound(options.teaserSoundResource());
	}

	public onReelBounce(reelView: ReelView<SymbolView>): void {
		// if reel contains new mysteries, play teaser sound
		if (this.nudgeUpService.reelsWithNewMysteries[reelView.reelIndex] > 0) {
			void this.teaserSound.play();
		}
	}
}
